import mapboxgl from "mapbox-gl";
import { mapboxConfig } from "./config.js";

// Initialize map when DOM is ready
document.addEventListener("DOMContentLoaded", function () {
  const mapContainer = document.querySelector(".mapbox-map");

  if (!mapContainer) {
    console.warn("Map container not found");
    return;
  }

  // Set access token
  mapboxgl.accessToken = mapboxConfig.accessToken;

  const map = new mapboxgl.Map({
    container: mapContainer,
    style: mapboxConfig.style,
    center: mapboxConfig.center,
    zoom: mapboxConfig.zoom,
    scrollZoom: mapboxConfig.scrollZoom,
    dragPan: mapboxConfig.dragPan,
    dragRotate: mapboxConfig.dragRotate,
    keyboard: mapboxConfig.keyboard,
    doubleClickZoom: mapboxConfig.doubleClickZoom,
    touchZoomRotate: mapboxConfig.touchZoomRotate,
  });

  // Add markers when map loads
  map.on("load", function () {
    if (window.mapData && window.mapData.companies) {
      window.mapData.companies.forEach((company) => {
        if (company.lat && company.lng) {
          // Create a new DOM element for each marker
          const markerIcon = document.createElement("div");
          markerIcon.className = "custom-marker";
          markerIcon.style.backgroundImage = `url(${window.themeUrl}/images/icon/marker/purple.svg)`;
          markerIcon.style.width = "16px";
          markerIcon.style.height = "32px";
          markerIcon.style.backgroundSize = "contain";
          markerIcon.style.backgroundRepeat = "no-repeat";
          markerIcon.style.backgroundPosition = "center bottom";

          // Convert coordinates to numbers to ensure they're not strings
          const lng = parseFloat(company.lng);
          const lat = parseFloat(company.lat);

          console.log(`Adding marker for ${company.name} at [${lng}, ${lat}]`);

          new mapboxgl.Marker(markerIcon)
            .setLngLat([lng, lat])
            .setPopup(
              new mapboxgl.Popup({ offset: 25 }).setHTML(`
                <strong>${company.name}</strong><br/>
                ${company.address}
              `)
            )
            .addTo(map);
        }
      });
    }
  });

  // Add navigation controls with accessibility
  const navControl = new mapboxgl.NavigationControl({
    showCompass: true,
    showZoom: true,
    visualizePitch: false,
  });

  // Add ARIA labels to navigation controls
  navControl.onAdd = function (map) {
    const container = mapboxgl.NavigationControl.prototype.onAdd.call(this, map);

    // Add ARIA labels to zoom buttons
    const zoomInButton = container.querySelector(".mapboxgl-ctrl-zoom-in");
    const zoomOutButton = container.querySelector(".mapboxgl-ctrl-zoom-out");
    const compassButton = container.querySelector(".mapboxgl-ctrl-compass");

    if (zoomInButton) {
      zoomInButton.setAttribute("aria-label", "Zoom in");
      zoomInButton.setAttribute("role", "button");
      zoomInButton.setAttribute("tabindex", "0");
    }

    if (zoomOutButton) {
      zoomOutButton.setAttribute("aria-label", "Zoom out");
      zoomOutButton.setAttribute("role", "button");
      zoomOutButton.setAttribute("tabindex", "0");
    }

    if (compassButton) {
      compassButton.setAttribute("aria-label", "Reset compass");
      compassButton.setAttribute("role", "button");
      compassButton.setAttribute("tabindex", "0");
    }

    return container;
  };

  map.addControl(navControl);
});
